import { useState } from "react";
import Model from "@/components/common/model.component";
import Button from "@/components/common/form/button";
import { useTranslation } from "react-i18next";
const ConfirmDelete = ({
  setShowModel,
  showModel,
  id,
  deleteTrigger,
  mutate = null,
  setRefresh,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  if (!id) {
    <div></div>;
  }

  return (
    <Model
      show={showModel}
      width="w-auto"
      onClose={(e) => {
        setShowModel(false);
      }}
    >
      <div className="flex flex-col items-center justify-center gap-3 py-2">
        <div className="flex items-center gap-1 mt-4 text-2xl font-semibold text-mako">
          {t("Delete")}
        </div>
        <div className="text-center text-mako ">
          {t("Are you sure you want to delete?")}
        </div>
      </div>
      <Button
        title={t("cancel")}
        className="w-full flex items-center justify-center  gap-2  h-[35px] font-bold text-[#727171] rounded-md cursor-pointer  border border-[#727171] mt-5"
        click={() => setShowModel(false)}
      />
      <Button
        loading={loading}
        title={t("Confirm")}
        className="w-full h-[35px] text-white rounded-lg bg-main  text-md "
        click={async () => {
          setLoading(true);
          await deleteTrigger(id);
          setLoading(false);
          mutate && mutate();
          setShowModel(false);
          setRefresh(1);
        }}
      />
    </Model>
  );
};
export default ConfirmDelete;
